import { SchemaDatapoint, SchemaSection } from '@rossum/api-client/schemas';
import { mapSchemaField } from '../../../../../../schemas/mapSchemaField';
import { QueryObject } from '../types';

export const filterSchemaContentForQuery = (
  schemaContent: SchemaSection[],
  fieldSchemaId: string,
  query: QueryObject
): SchemaSection[] => {
  return mapSchemaField(schemaContent, fieldSchemaId, datapoint =>
    updateDatapointWithQuery(datapoint, query)
  );
};

/**
 * Updates a datapoint's matching configuration to include only the specified query.
 * Only updates if the datapoint has a matching configuration with queries.
 */
const updateDatapointWithQuery = <T extends SchemaDatapoint>(
  datapoint: T,
  query: QueryObject
): T => {
  // Type guard: only non-button datapoints have matching
  if (datapoint.type === 'button') return datapoint;

  const { matching } = datapoint;
  const configuration = matching?.['configuration'];

  if (!configuration) return datapoint;

  return {
    ...datapoint,
    matching: {
      ...matching,
      configuration: {
        ...configuration,
        queries: [query],
      },
    },
  };
};
